import React, { useEffect, useState } from "react";
import SingleGroup from "./SingleGroup";
import axios from "../../axios";
import "./createMoreGroups.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import assets from "../../assets/assets";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Stack,
  Typography,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

function GroupList() {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    assessmentTypes: null,
    subjects: null,
  });

  const [page, setPage] = useState(1);
  const LIMIT = 20;

  // const { standards, sections } = dropdownLists;
  const [standard, setStandard] = useState("");
  const [section, setSection] = useState("");
  const [standardArr, setStandardArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON =
    JSON.parse(general_role) === null ? [] : JSON.parse(general_role);
  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON =
    JSON.parse(classTeacher) === null ? [] : JSON.parse(classTeacher);
  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON =
    JSON.parse(cordinator) === null ? [] : JSON.parse(cordinator);

  const [deleteGroupId, setDeleteGroupId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const getGroups = async () => {
    try {
      setIsLoading(true);
      let res = await axios.get(
        `api/v1/group/filterForTeacher/teacherId/${teacher_id}?type=Query&_limit=${LIMIT}&_page=${page}` +
          `${standard ? `&standardId=${standard}` : ``}` +
          `${section ? `&sectionId=${section}` : ``}`,
      );

      // res && setGroups(res.data.data.filter((obj)=>!obj.isDeleted && obj.type === "Query"));
      if (res) {
        setGroups(res.data.data);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!standard) {
      setSection("");
    }

    getGroups();
    // if (CTRole_Information && CTRole_Information.length > 0) {
    //   CTRole_Information?.forEach((obj) => {
    //     if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //       standardList.push(obj.standard_id);
    //     }
    //     if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //       sectionList.push(obj.section_id);
    //     }
    //   });
    // }

    // if (CoRole_Information && CoRole_Information.length > 0) {
    //   CoRole_Information?.forEach((obj) => {
    //     if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //       standardList.push(obj.standard_id);
    //     }
    //     if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //       sectionList.push(obj.section_id);
    //     }
    //   });
    // }

    // if (general_role && general_role.length > 0) {
    //   general_role?.forEach((obj) => {
    //     if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //       standardList.push(obj.standard_id);
    //     }
    //     if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //       sectionList.push(obj.section_id);
    //     }
    //   });
    // }

    // standardList.length > 0 &&
    //   setDropdownLists((prev) => ({ ...prev, standards: standardList }));
    // sectionList.length > 0 &&
    //   setDropdownLists((prev) => ({ ...prev, sections: sectionList }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standard, section, page]);

  const handleDeleteGroup = (groupId) => {
    setDeleteGroupId(groupId);
    setOpenDeleteModal(true);
  };

  const confirmDeleteGroup = async () => {
    try {
      setIsLoading(true);

      const res = await axios.delete(`/api/v1/group/delete/${deleteGroupId}`, {
        data: { teacher_id },
      });

      if (res?.status === 200) {
        toast.success("Group deleted successfully");

        await getGroups(); // 🔥 reload data
      } else {
        toast.error("Failed to delete group");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while deleting");
    } finally {
      setIsLoading(false);
      setOpenDeleteModal(false);
      setDeleteGroupId(null);
    }
  };

  let tempSectionArr = [];
  function addUniqueObjectToArraystand(obj) {
    if (
      !standardArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
    ) {
      standardArr.push(obj);
    }
  }
  const dropDownHelper = () => {
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
    setStandardArr([...standardArr]);
  };

  function addUniqueObjectToArraysect(obj) {
    if (
      !tempSectionArr.some(
        (item) => JSON.stringify(item) === JSON.stringify(obj),
      )
    ) {
      tempSectionArr.push(obj);
    }
  }

  const handleDropDownSec = () => {
    const selectedStandardId = standard;
    tempSectionArr = [];
    generalRole_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.forEach((obj) => {
      if (obj?.standard_id?.id === selectedStandardId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    setSectionArr([...tempSectionArr]);
  };

  useEffect(() => {
    dropDownHelper();
    setSectionArr([]);
    handleDropDownSec();
  }, [standard]);

  return (
    <>
      <div
        className="all_createGroup_container m-3"
        style={{
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 120px)", // adjust if header height differs
        }}
      >
        <div className="m-1 p-4">
          <div className="d-flex flex-column">
            <div
              onClick={() => (isPopupOpen ? setIsPopupOpen(false) : "")}
              className="d-flex justify-content-between align-items-center "
            >
              <span className="poppins-semibold fs-5 ms-5">Groups</span>
              <Link to="/createGroups">
                <button className="creteBtnstd">
                  <FontAwesomeIcon icon={faPlus} /> Create Group
                </button>
              </Link>
            </div>
            <hr
              style={{
                width: "100%",
                borderBottom: "2px solid #668598",
              }}
            />
            <div className="d-flex justify-content-end">
              <FormControl size="small" sx={{ minWidth: 150, mr: 2 }}>
                <InputLabel>Select Class</InputLabel>
                <Select
                  value={standard}
                  onChange={(e) => {
                    setStandard(e.target.value);
                    setSection("");
                    setPage(1);
                  }}
                  label="Select Class"
                >
                  <MenuItem value="">Select All</MenuItem>
                  {standardArr?.length > 0 &&
                    [...standardArr]
                      .sort((a, b) => {
                        const aNum = Number(a.name);
                        const bNum = Number(b.name);

                        const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                        if (bothNumeric) {
                          return aNum - bNum; // numeric sort
                        }

                        return a.name.localeCompare(b.name); // alphabetical sort
                      })
                      .map((standard, index) => (
                        <MenuItem
                          key={index}
                          value={standard?.id}
                          name={standard?.name}
                        >
                          {standard?.name}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>

              <FormControl
                size="small"
                sx={{ minWidth: 150, mr: 2 }}
                disabled={!standard}
              >
                <InputLabel>Select Section</InputLabel>
                <Select
                  value={section}
                  onChange={(e) => {
                    setSection(e.target.value);
                    setPage(1);
                  }}
                  label="Select Section"
                >
                  <MenuItem value="">Select All</MenuItem>
                  {standard &&
                    sectionArr?.map((section, index) => (
                      <MenuItem key={index} value={section.id}>
                        {section.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
        <div
          className="orange-scrollBar d-flex flex-column align-items-center"
          style={{
            flex: 1, // 🔥 take remaining height
            width: "100%",
            overflowY: "auto",
            paddingBottom: "90px", // 🔥 space for pagination footer
          }}
        >
          {isLoading ? (
            <div className="spinner-border text-primary" />
          ) : groups.length > 0 ? (
            <>
              {groups.map((item) => (
                <SingleGroup
                  key={item.id}
                  group={item}
                  onDelete={() => handleDeleteGroup(item.id)}
                />
              ))}
            </>
          ) : (
            <span className="text-danger fs-5">No Groups Found</span>
          )}
        </div>

        {/* PAGINATION */}
        {(groups.length === LIMIT || page > 1) && (
          <div
            style={{
              position: "sticky",
              bottom: 12,
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Paper
              elevation={4}
              sx={{
                px: 3,
                py: 1.5,

                width: "fit-content", // ✅ NOT full width
                minWidth: 320,

                borderRadius: "999px", // ✅ premium pill shape
                border: "1px solid #fed7aa",

                background:
                  "linear-gradient(135deg, rgba(255,247,237,0.95), rgba(255,237,213,0.95))",
                backdropFilter: "blur(8px)",
              }}
            >
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
              >
                {/* LEFT INFO */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: "#9a3412",
                    whiteSpace: "nowrap",
                  }}
                >
                  Page {page} · {LIMIT} per page
                </Typography>

                {/* PAGINATION */}
                <Pagination
                  count={groups.length < LIMIT ? page : page + 1}
                  page={page}
                  onChange={(_, value) => setPage(value)}
                  shape="rounded"
                  size="small"
                  color="warning"
                  siblingCount={1}
                  boundaryCount={1}
                />
              </Stack>
            </Paper>
          </div>
        )}

        <Dialog
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
        >
          <DialogTitle>Delete Group</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this group? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => setOpenDeleteModal(false)}
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              onClick={confirmDeleteGroup}
              color="error"
              variant="danger"
              disabled={isLoading}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default GroupList;
